import getCsrfToken from 'bits/csrf_token'
import device from 'bits/device'
import window, { ww } from 'bits/global'

export function reload (): void {
  window.location.reload()
}

export function currentUrl (): string {
  return window.location.href
}

interface RedirectOptions {
  method?: string,
  target?: string,
}

export function navigateTo (url: string, options: RedirectOptions = {}): void {
  const { method, target } = options

  if (method && method.toLowerCase() !== 'get') {
    const fakeForm = document.createElement('form')

    const csrfTokenInput = document.createElement('input')
    csrfTokenInput.type = 'hidden'
    csrfTokenInput.name = 'authenticity_token'
    csrfTokenInput.value = getCsrfToken()

    const submitButton = document.createElement('button')
    submitButton.type = 'submit'

    fakeForm.action = url
    fakeForm.method = method
    fakeForm.appendChild(csrfTokenInput)
    fakeForm.appendChild(submitButton)
    document.body.appendChild(fakeForm)
    fakeForm.submit()
  } else if (device.desktopApp) {
    ww.navigateDesktopApp && ww.navigateDesktopApp(url, target)
  } else if (target) {
    window.open(url, target)
  } else {
    window.location.href = url
  }
}
